module.exports = __webpack_public_path__ + "static/media/couches-10.df9ea3ec.jpg";